module.exports = __webpack_public_path__ + "img/icon-internet-home.171f2dd9.svg";